<template>
  <div class="horoscope_top">
    <section v-if="birthday != null">
      <div class="horoscope_box">
        <img :src="`${horoscopeImage}`" alt="12星座" />
        <router-link :to="{ name: 'HoroscopeResult' }" class="btn arrow alpha">占う</router-link>
      </div>
      <p class="text_center"><router-link :to="{ name: 'UserProfileChange' }" class="arrow link_main--text">生年月日を変更する</router-link></p>
      <p class="horoscope_box_text">
        ※12星座占いは1日に1回のみ行なえます。<br>
        1回、星座を選択し、結果をご覧になった場合、2回目以降はどの星座を選択されても運勢結果は変わらず表示されますので予めご了承下さい。
      </p>
    </section>
    <section v-else class="horoscope_unregistered text_center">
      <p>12星座占いをするには<br>生年月日を登録して下さい。</p>
      <p><router-link :to="{ name: 'UserProfileChange' }" class="arrow link_main--text">生年月日を登録する</router-link></p>
    </section>
  </div>
</template>

<script>
import moment from 'moment'
import { HOROSCOPES } from '@/helper/constant'

export default {
  name: 'HoroscopeTop',
  data () {
    return {
      user: this.$store.getters.loginUser || null
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    },
    birthday () {
      let day = null
      if (this.user.user.birthday != null) {
        day = this.user.user.birthday.replaceAll('/', '-')
      }
      return day
    },
    horoscopeImage () {
      const day = this.birthday
      if (day != null) {
        const m = moment(day)
        // 月日を4桁の数値にする 1/31 -> 131
        const birthMonthAndDay = ((m.month() + 1) * 100) + m.date()
        let horo = HOROSCOPES.find(g => g.value >= birthMonthAndDay)
        if (typeof horo === 'undefined') {
          horo = HOROSCOPES[0]
        }
        return horo.image
      } else {
        return ''
      }
    }
  },
  watch: {
    loginUser (val, old) {
      this.user = val
    }
  }
}
</script>
